module.exports = __webpack_public_path__ + "img/background-dd.dd13cab5.png";